import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const defaultProps = {
  adornment: null,
};

const propTypes = {
  input: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({}).isRequired,
  adornment: PropTypes.shape({
    position: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
};

const WrappedTextField = ({
  input,
  label,
  adornment,
  meta: { touched, error, invalid },
  ...rest
}) =>
  adornment ? (
    <TextField
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...rest}
      InputProps={{
        [`${adornment.position}Adornment`]: (
          <InputAdornment position={adornment.position}>{adornment.value}</InputAdornment>
        ),
      }}
    />
  ) : (
    <TextField
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...rest}
    />
  );

WrappedTextField.propTypes = propTypes;
WrappedTextField.defaultProps = defaultProps;

export default WrappedTextField;
